import { formatCopInput, parseCopInput } from "../model/alertManagementConstants";
import { toSalePriceNumber } from "../model/subsanarPrices";
import { SubsanarPriceInput } from "./detail.styles";

// Valida que el nuevo precio esté dentro del rango de estudio de mercado del producto.
const isValidPrice = (value, record) => {
  const numeric = toSalePriceNumber(value);
  if (numeric == null) return false;
  const min = Number(record?.precio_minimo ?? 0);
  const max = Number(record?.precio_maximo ?? 0);
  if (max > 0) return numeric >= min && numeric <= max;
  return numeric >= min;
};

// Celda "Nuevo precio de venta" en la tabla de Subsanar.
// Se inicializa con `resultado` del producto y queda editable; el estado por fila
// vive en el hook (keyed por rowKey). Si `value` es undefined, la fila no se ha tocado.
export const SubsanarPriceCell = ({ record, value, onChange }) => {
  const displayValue = value !== undefined ? value : toSalePriceNumber(record?.resultado);
  const showError = displayValue != null && !isValidPrice(displayValue, record);

  return (
    <SubsanarPriceInput
      value={displayValue ?? null}
      min={0}
      controls={false}
      placeholder="$ 0"
      formatter={formatCopInput}
      parser={parseCopInput}
      status={showError ? "error" : ""}
      onChange={(next) => onChange(record.rowKey, next)}
    />
  );
};